import {createGlobalStyle} from 'styled-components';

import {isPWAInstalled} from '@shared_web/lib/pwa';
import {optional, optionalPx} from '@shared_web/lib/styled_utils';

export const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
    width: 100%;
    overflow: hidden;
    font-weight: 400;
    ${p => optional('font-family', p.theme.main?.fontFamily)};
    ${p => optionalPx('font-size', p.theme.main?.fontSize)};
    ${p => optionalPx('line-height', p.theme.main?.lineHeight)};
    ${p => optional('background-color', p.theme.main?.backgroundColor)};
    ${p => optional('color', p.theme.main?.textColor)};    
  }
  html {
    ${() => optional('height', isPWAInstalled() ? '100vh' : undefined)}
  }
  [hidden] {
    display: none !important;
  }
`;
